const LAY_DANH_SACH_NHOM_MENU_THANH_CONG = (state, danhSachNhomMenu) => {
  state.danhSachNhomMenu = danhSachNhomMenu;
};

const LAY_CHI_TIET_NHOM_MENU_THANH_CONG = (state, nhomMenu) => {
  state.nhomMenu = nhomMenu;
};

export default {
  LAY_DANH_SACH_NHOM_MENU_THANH_CONG,
  LAY_CHI_TIET_NHOM_MENU_THANH_CONG
};
